import { IMobileHome } from 'mhbo-js'
import React from 'react'
import { FormattedNumber } from 'react-intl'
import { Col, Row } from 'reactstrap'
import getBaseUrl from '../getBaseUrl'

interface IProps {
  homeListing: IMobileHome
}

const BuyFooter: React.FC<IProps> = (props: IProps) => {
  const {
    homeListing: {
      askingPrice,
      address,
      numBathrooms,
      numBedrooms,
      communityName,
      communityId,
      totalFootage,
    },
  } = props
  return (
    <div className="listingCell__preview_cell_footer_white">
      <Row className="align-items-center">
        <Col xs={3} md={4}>
          <p className="listingCell__footer_content_large_text_navy_padded">
            <FormattedNumber
              // eslint-disable-next-line react/style-prop-object
              style="currency"
              currency="USD"
              currencyDisplay="symbol"
              value={askingPrice!}
              minimumFractionDigits={0}
            />
          </p>
        </Col>
        <Col xs={9} md={8}>
          <Row>
            <Col xs={12}>
              <p className="listingCell__footer_content_navy_right">
                <b>{numBedrooms}</b>
                {` bed, `}
                <b>{numBathrooms}</b>
                {` bath, `}
                <b>{totalFootage}</b>
                {` sqft`}
              </p>

              <p className="listingCell__footer_content_navy_right">{`${address.numberAndStreet}, ${address.city}, ${address.state}`}</p>
              {communityId && communityId > 0 ? (
                <p
                  className="listingCell__community_link"
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={(e) => {
                    e.stopPropagation()
                    window.open(
                      `${getBaseUrl()}/communities/${communityId}`,
                      '_blank'
                    )
                  }}
                >
                  {communityName}
                </p>
              ) : null}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default BuyFooter
